import { Spin } from "antd";
import React from "react";
import CustomLoaderIcon from "../../CustomIcons/Icons/Essetional/CustomLoaderIcon";

function CircleSpin(props) {
  const size = {
    small: 50,
    medium: 60,
    large: 80,
  };
  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        width: "100%",
      }}
    >
      <Spin
        indicator={
          <CustomLoaderIcon
            style={{
              fontSize: size[props?.size] || 58,
            }}
            spin
          />
        }
      />
    </div>
  );
}

export default CircleSpin;
